/* BaristaYOU – Setup Builder Quick Add
   Single-variant products: one-tap add without leaving the product page.
   Multi-variant products stay on "Optionen wählen" to avoid wrong selections. */
(function () {
  'use strict';

  var CACHE = new Map();
  var DIRTY_KEY = '__baristaYOUCartDirty';
  var TOAST_TIMER = null;

  function productJsonUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/$/, '') + '.js';
    } catch (e) {
      return null;
    }
  }

  function fetchProduct(href) {
    var url = productJsonUrl(href);
    if (!url) return Promise.reject(new Error('Ungültige Produkt-URL'));
    if (CACHE.has(url)) return CACHE.get(url);

    var request = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Produktdaten konnten nicht geladen werden');
      return response.json();
    });

    CACHE.set(url, request);
    return request;
  }

  function ensureToast() {
    var toast = document.querySelector('[data-by-upsell-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'by-upsell-toast';
    toast.setAttribute('data-by-upsell-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.innerHTML =
      '<span class="by-upsell-toast__check" aria-hidden="true">✓</span>' +
      '<span class="by-upsell-toast__copy"><strong data-by-toast-title>Zum Setup hinzugefügt</strong><span data-by-toast-sub>Liegt jetzt in deinem Warenkorb.</span></span>' +
      '<a class="by-upsell-toast__link" data-by-toast-cart href="/cart">Warenkorb →</a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(title, success, message) {
    var toast = ensureToast();
    var titleNode = toast.querySelector('[data-by-toast-title]');
    var subNode = toast.querySelector('[data-by-toast-sub]');
    var cartLink = toast.querySelector('[data-by-toast-cart]');
    var check = toast.querySelector('.by-upsell-toast__check');

    if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
      cartLink.href = window.theme.routes.cart_url;
    }

    titleNode.textContent = success ? title : 'Konnte nicht hinzugefügt werden';
    subNode.textContent = success ? 'Liegt jetzt in deinem Warenkorb.' : (message || 'Bitte versuche es noch einmal.');
    check.textContent = success ? '✓' : '!';
    toast.classList.toggle('is-error', !success);
    toast.classList.add('is-visible');

    clearTimeout(TOAST_TIMER);
    TOAST_TIMER = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, success ? 3200 : 4200);
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: {
        cartCount: cart.item_count,
        cart: cart,
        source: 'baristayou-upsell-quick-add'
      }
    }));

    window[DIRTY_KEY] = true;
  }

  function refreshCount() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden');
      return response.json();
    }).then(function (cart) {
      updateCartCount(cart);
      return cart;
    });
  }

  function replaceWithQuickAdd(cta, product, variant) {
    if (!cta || cta.dataset.byQuickReady === 'true') return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = cta.className + ' up-quick-add';
    button.setAttribute('data-by-quick-add', '');
    button.setAttribute('data-variant-id', variant.id);
    button.setAttribute('data-product-title', product.title || 'Produkt');
    button.setAttribute('aria-label', (product.title || 'Produkt') + ' zum Setup hinzufügen');
    button.innerHTML = '<span data-by-quick-label>+ Zum Setup hinzufügen</span>';
    button.dataset.byQuickReady = 'true';
    cta.replaceWith(button);

    var card = button.closest('.up-card');
    if (card) {
      card.classList.add('up-card--quick-add');
      var status = card.querySelector('.up-status');
      if (status && status.textContent.trim() === 'Bestellbar') {
        status.lastChild.textContent = ' Direkt bestellbar';
      }
    }
  }

  function markOptions(cta) {
    if (!cta || cta.dataset.byQuickReady === 'true') return;
    cta.textContent = 'Optionen wählen';
    cta.dataset.byQuickReady = 'true';
    cta.classList.add('up-cta--options');
  }

  function enhanceFromServerData(card, cta) {
    if (!card.hasAttribute('data-by-single-variant')) return false;
    card.dataset.byQuickChecked = 'true';

    var single = card.getAttribute('data-by-single-variant') === 'true';
    if (!single) {
      markOptions(cta);
      return true;
    }

    var variantId = Number(card.getAttribute('data-by-variant-id'));
    var available = card.getAttribute('data-by-variant-available') === 'true';
    var title = card.getAttribute('data-by-product-title') || 'Produkt';
    if (available && variantId) {
      replaceWithQuickAdd(cta, { title: title }, { id: variantId, available: true });
    } else {
      cta.dataset.byQuickReady = 'true';
    }
    return true;
  }

  function enhanceCard(card) {
    if (!card || card.dataset.byQuickChecked === 'true') return;
    var cta = card.querySelector('.up-cta:not(.up-cta-ghost)');
    if (!cta || cta.tagName !== 'A') return;

    if (enhanceFromServerData(card, cta)) return;

    card.dataset.byQuickChecked = 'true';
    cta.setAttribute('aria-busy', 'true');

    fetchProduct(cta.href).then(function (product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      if (variants.length === 1 && variants[0] && variants[0].available) {
        replaceWithQuickAdd(cta, product, variants[0]);
      } else {
        markOptions(cta);
      }
    }).catch(function () {
      cta.dataset.byQuickReady = 'true';
    }).finally(function () {
      if (cta && cta.removeAttribute) cta.removeAttribute('aria-busy');
    });
  }

  function enhancePanel(panel) {
    if (!panel) return;
    panel.querySelectorAll('.up-card').forEach(enhanceCard);
  }

  function enhanceSection(section) {
    if (!section || section.dataset.byQuickAddInit === 'true') return;
    section.dataset.byQuickAddInit = 'true';

    var activePanel = section.querySelector('.up-panel.is-active');
    enhancePanel(activePanel);

    section.addEventListener('click', function (event) {
      var tab = event.target.closest('.up-tab');
      if (tab) {
        window.requestAnimationFrame(function () {
          enhancePanel(section.querySelector('.up-panel.is-active'));
        });
      }

      var button = event.target.closest('[data-by-quick-add]');
      if (!button || !section.contains(button)) return;
      event.preventDefault();

      if (button.disabled || button.classList.contains('is-loading')) return;

      var variantId = Number(button.getAttribute('data-variant-id'));
      var title = button.getAttribute('data-product-title') || 'Produkt';
      var label = button.querySelector('[data-by-quick-label]');
      var original = '+ Zum Setup hinzufügen';
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';

      if (!variantId) return;

      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = 'Wird hinzugefügt …';

      fetch(addUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Produkt konnte nicht hinzugefügt werden');
          }
          return data;
        });
      }).then(function () {
        return refreshCount();
      }).then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        if (label) label.textContent = 'Hinzugefügt ✓';
        showToast(title, true);

        document.dispatchEvent(new CustomEvent('by:upsell:add', {
          bubbles: true,
          detail: { variantId: variantId, productTitle: title }
        }));

        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
          if (label) label.textContent = original;
        }, 2200);
      }).catch(function (error) {
        button.classList.remove('is-loading');
        button.classList.add('has-error');
        button.disabled = false;
        if (label) label.textContent = 'Erneut versuchen';
        showToast(title, false, error && error.message);

        setTimeout(function () {
          button.classList.remove('has-error');
          if (label) label.textContent = original;
        }, 2800);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-section-type="upsell-tabs"]').forEach(enhanceSection);
  }

  /* Keep the drawer silent while shoppers build their setup. Refresh it only
     when they actually open the cart, so its contents are current. */
  document.addEventListener('click', function (event) {
    var cartToggle = event.target.closest('[data-cart-toggle]');
    if (!cartToggle || !window[DIRTY_KEY]) return;
    window[DIRTY_KEY] = false;

    if (document.querySelector('cart-drawer')) {
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
